import { createAsyncThunk } from '@reduxjs/toolkit';
import { Modes } from '@components/Modal';
import { ThunkApiConfig } from 'models/ThunkApiConfig';
import {
  modalClose,
  ModalClosePayload,
  resetClosingClass,
  setClosingClass,
} from './actions';
import { CLOSING_TIMEOUT_MS, CLOSING_TIMEOUT_OFFSET_MS } from './constants';
import { selectModalIsAnimated, selectModalMode } from './selectors';

export const onModalCloseRequest = createAsyncThunk.withTypes<ThunkApiConfig>()(
  'modal/close/request',
  async (
    { animated, callBack, id }: ModalClosePayload,
    { dispatch, getState },
  ) => {
    const state = getState();
    const mode = selectModalMode(id)(state);
    const animatedFromStore = selectModalIsAnimated(id)(state);

    if (
      mode === Modes.rightSlide &&
      (animated !== undefined ? animated : animatedFromStore)
    ) {
      dispatch(setClosingClass({ id }));

      await new Promise((resolve) =>
        setTimeout(resolve, CLOSING_TIMEOUT_MS - CLOSING_TIMEOUT_OFFSET_MS),
      );

      dispatch(resetClosingClass({ id }));
    }

    dispatch(modalClose.success({ id }));

    if (callBack) {
      callBack();
    }
  },
);
